import { createBrowserRouter } from 'react-router-dom';
import {
  Dashboard,
  Profile,
  Register,
  ResetPassword,
  AccessDenied,
  UserImpersonation
} from '../pages';
import { AuthGuard } from '../utils';
import { Layout } from '../components';
import NavigateProvider from "./AppWrapper"; 
import { NotFound } from '../pages/default/NotFound.js';
import { DetailedLogs } from '../components/detailed-logs/DetailedLogs.js';
import { PlatformDashboard } from '../pages/dashboard/PlatformDashboard.js';
import { CustomerAnalyticsDashboard } from '../pages/dashboard/CustomerAnalyticsDashboard.js';
import { ApiLogs } from '../pages/dashboard/ApiLogs.js';
import { ViewLogs } from '../pages/dashboard/ViewLogs.js';
import { ApiAnalyticsGrouped } from '../pages/dashboard/ApiAnalyticsGrouped.js';

const router = createBrowserRouter([
  {
    path: '/',
    element: <NavigateProvider />, 
    children: [
      {
        path: '/',
        element: (
          <AuthGuard>
            <Layout />
          </AuthGuard>
        ),
        children: [
          {
            index: true,
            element: <PlatformDashboard />,
          },
          {
            path: '/customer-analytics',
            element: <CustomerAnalyticsDashboard />,
          },
          {
            path: '/dashboard/:companyName',
            element: <Dashboard />,
          },
          {
            path: '/dashboard/:companyName/view-logs',
            element: <ViewLogs />,
          },
          {
            path: '/dashboard/:companyName/api-analytics-grouped',
            element: <ApiAnalyticsGrouped />,
          },
          {
            path: '/customer-analytics/api-logs/:companyName',
            element: <ApiLogs />,
          },
          {
            path: '/company-users',
            element: <UserImpersonation />,
          },
          {
            path: '/profile',
            element: <Profile />,
          },
        ],
        },
        {
          path: '/login',
          element: <Register />,
        },
        {
          path: '/magic-login',
          element: <Register />,
        },
        {
          path: '/reset-password',
          element: <ResetPassword />,
        },
        {
          path: "*" ,
          element: <NotFound />
        },
    ],
  },
]);
export default router;